import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/icon/FluentIcon.module_built.css";
const classes = {"icon--add-document":"wdGN4aG_icon--add-document","appearance--text":"wdGN4aG_appearance--text","fluent-icon":"wdGN4aG_fluent-icon","icon--info-16":"wdGN4aG_icon--info-16","icon--attachment":"wdGN4aG_icon--attachment","icon--keypad":"wdGN4aG_icon--keypad","icon--send":"wdGN4aG_icon--send"}
export default classes

const _icon__add_document0 = classes["icon--add-document"]
export { _icon__add_document0 as "icon--add-document" }

const _appearance__text0 = classes["appearance--text"]
export { _appearance__text0 as "appearance--text" }

const _fluent_icon0 = classes["fluent-icon"]
export { _fluent_icon0 as "fluent-icon" }

const _icon__info_160 = classes["icon--info-16"]
export { _icon__info_160 as "icon--info-16" }

const _icon__attachment0 = classes["icon--attachment"]
export { _icon__attachment0 as "icon--attachment" }

const _icon__keypad0 = classes["icon--keypad"]
export { _icon__keypad0 as "icon--keypad" }

const _icon__send0 = classes["icon--send"]
export { _icon__send0 as "icon--send" }
